import { messages as messages$1 } from '../../messages/en.json.mjs';

const messages = messages$1;

export { messages };
//# sourceMappingURL=en.mjs.map
